const _excluded = ["renderEndSlot", "showPasswordLabel"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import HideIcon from "@bolteu/kalep-react-icons/dist/Hide";
import ShowIcon from "@bolteu/kalep-react-icons/dist/Show";
import { Tooltip } from "../Tooltip";
import { cx } from "../../helpers/utils/cx";
import { BaseTextField } from "./BaseTextField";
export const DEFAULT_SHOW_PASSWORD_ARIA_LABEL = "Toggle Password Visibility";
export const PasswordTextField = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      renderEndSlot: renderEndSlotProp,
      showPasswordLabel = DEFAULT_SHOW_PASSWORD_ARIA_LABEL
    } = _ref,
    baseTextFieldProps = _objectWithoutProperties(_ref, _excluded);
  const [shouldShowPassword, setShouldShowPassword] = React.useState(false);
  const handleShowPasswordButtonClick = React.useCallback(function toggleShowPassword() {
    setShouldShowPassword(!shouldShowPassword);
  }, [shouldShowPassword]);
  const renderEndSlot = React.useCallback(function endSlotRenderer(props) {
    function renderEndSlotDefault(propsForRender) {
      const iconSize = propsForRender.size === "sm" ? "sm" : "lg";
      const Icon = shouldShowPassword ? HideIcon : ShowIcon;
      return /*#__PURE__*/React.createElement(Tooltip, {
        content: propsForRender.showPasswordLabel ?? ""
      }, /*#__PURE__*/React.createElement("button", {
        "aria-checked": shouldShowPassword,
        "aria-label": propsForRender.showPasswordLabel,
        className: cx("border-0 bg-transparent p-2 text-tertiary cursor-pointer"),
        onClick: handleShowPasswordButtonClick,
        role: "switch",
        type: "button"
      }, /*#__PURE__*/React.createElement(Icon, {
        size: iconSize,
        className: cx("block")
      })));
    }
    return renderEndSlotProp ? renderEndSlotProp(props, renderEndSlotDefault) : renderEndSlotDefault(props);
  }, [handleShowPasswordButtonClick, renderEndSlotProp, shouldShowPassword]);
  return /*#__PURE__*/React.createElement(BaseTextField, _extends({}, baseTextFieldProps, {
    ref: ref,
    renderEndSlot: renderEndSlot,
    type: shouldShowPassword ? "text" : "password",
    showPasswordLabel: showPasswordLabel
  }));
});